import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=643121ec&scoped=true&"
import script from "./rejectDialog.vue?vue&type=script&lang=js&"
export * from "./rejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&id=643121ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643121ec",
  null
  
)

export default component.exports